module.exports = __webpack_public_path__ + "img/Machine-Out-Of-Order-Sign-Template.fcd78c06.jpg";